import React from "react";
import { useRemoveQueryNavigation } from "helpers/hooks/url";
import { destroy } from "ducks/propertyTemplates";
import { connect } from "react-redux";
import ConfirmModal from "components/ConfirmModal";
const DestroyPropertyTemplate = ({ destroy, id }) => {
  const closeDestroyModal = useRemoveQueryNavigation("deletePropertyTemplate");

  return (
    <ConfirmModal
      title="Datenformat löschen"
      confirm={() => {
        destroy(id);
        closeDestroyModal();
      }}
      close={closeDestroyModal}
    />
  );
};

export default connect(null, { destroy })(DestroyPropertyTemplate);
